import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-left-active.png'
import _imports_1 from '@/assets/icon/arrow-left-default.png'
import _imports_2 from '@/assets/icon/arrow-right-active.png'
import _imports_3 from '@/assets/icon/arrow-right-default.png'


const _withScopeId = n => (_pushScopeId("data-v-1df9d4b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-4" }
const _hoisted_5 = { class: "box-carousel" }
const _hoisted_6 = {
  key: 0,
  class: "box-indicator"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_10 = { class: "col-12 offset-md-1 col-md-7" }
const _hoisted_11 = { class: "product-name" }
const _hoisted_12 = { class: "box-price" }
const _hoisted_13 = { class: "price" }
const _hoisted_14 = {
  key: 0,
  class: "price price-line-through"
}
const _hoisted_15 = { class: "sku-select" }
const _hoisted_16 = {
  key: 0,
  class: "box-purchase-option"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " Purchase option ", -1))
const _hoisted_18 = { class: "box-action" }
const _hoisted_19 = {
  key: 1,
  class: "box-description"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " Description ", -1))

import { ref, nextTick, computed } from 'vue';
  import { IVariant, IProduct, TPurchaseKind } from '@/types/product';
  import PurchaseOption from './purchase-option.vue';
  import { shoppingCartStore } from '@/stores';

  interface ICarousel {
    current: number;
    slidePrev?: () => void;
    slideNext?: () => void;
    handleSlideTo?: (index: number) => void;
  }

  interface IProps {
    variant: IVariant;
    product: IProduct;
    purchaseKind: TPurchaseKind;
    quatity: number;
  }

  interface IEmits {
    (event: 'select-variant', id: number): void;
    (event: 'update:purchase-kind', kind: TPurchaseKind): void;
    (event: 'update:quatity', quatity: number): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    variant: null,
    product: null,
    purchaseKind: null,
    quatity: null
  },
  emits: ["select-variant", "update:purchase-kind", "update:quatity"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'select-variant', id: number): void;
    (event: 'update:purchase-kind', kind: TPurchaseKind): void;
    (event: 'update:quatity', quatity: number): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    variant: IVariant;
    product: IProduct;
    purchaseKind: TPurchaseKind;
    quatity: number;
  }

  
  
  const boxImgs = ref<HTMLDivElement>();
  const carousel = ref<ICarousel>({ current: 0 });
  const images = computed(() => props.product.images.map(item => ({ imageUrl: item.url })));
  const variantOptions = computed(() => props.product.variants.map(item => ({ text: item.name, value: item.id })));
  const breadcurmbRoutes = computed(() => [
    {
      name: 'Home',
      to: { name: 'home' }
    },
    {
      name: 'Shop',
      to: { name: 'shop.index' }
    },
    {
      name: props.product.name
    }
  ]);

  const handleVariantChange = (variantId: any) => {
    emits('select-variant', variantId);
  };

  const handleSelectPurchaseKind = (kind: TPurchaseKind) => {
    emits('update:purchase-kind', kind);
  };

  const handleQuatityChange = (quatity: number) => {
    emits('update:quatity', quatity);
  };

  const onSwiperCurrentChange = async () => {
    await nextTick();
    const boxImage = boxImgs.value;
    if (boxImage) {
      const boxWidth = boxImage.offsetWidth;
      const img: HTMLElement | null = boxImage.querySelector('.active');
      if (img) {
        const imgWidth = img.offsetWidth;
        const imgOffsetLeft = img.offsetLeft;
        boxImage.scrollLeft = imgOffsetLeft - (boxWidth - imgWidth) / 2;
      }
    }

  };

  const handleAddToCart = () => {
    return shoppingCartStore.addToCart(props.variant.id, props.purchaseKind, props.quatity);
  };


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppCarousel = _resolveComponent("AppCarousel")!
  const _component_AppPrice = _resolveComponent("AppPrice")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_AppStepper = _resolveComponent("AppStepper")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBreadcurmb, {
        class: "section-breadcurmb",
        routes: _unref(breadcurmbRoutes)
      }, null, 8, ["routes"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AppCarousel, {
              ref_key: "carousel",
              ref: carousel,
              images: _unref(images),
              interval: 5000,
              autoplay: "",
              "hidden-dot": "",
              onChange: onSwiperCurrentChange
            }, null, 8, ["images"]),
            (_unref(images).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-ctrl btn-ctrl-left", { active: carousel.value.current !== 0 }])
                  }, [
                    _createElementVNode("img", {
                      class: "active-img",
                      src: _imports_0,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (carousel.value.slidePrev && carousel.value.slidePrev(...args)))
                    }),
                    _hoisted_7
                  ], 2),
                  _createElementVNode("div", {
                    ref_key: "boxImgs",
                    ref: boxImgs,
                    class: "box-imgs"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), (image, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: index,
                        src: image.imageUrl,
                        class: _normalizeClass({ active: index === carousel.value.current }),
                        onClick: ($event: any) => (carousel.value.handleSlideTo && carousel.value.handleSlideTo(index))
                      }, null, 10, _hoisted_8))
                    }), 128))
                  ], 512),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-ctrl btn-ctrl-right", { active: carousel.value.current + 1 !== _unref(images).length }])
                  }, [
                    _createElementVNode("img", {
                      class: "active-img",
                      src: _imports_2,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (carousel.value.slideNext && carousel.value.slideNext(...args)))
                    }),
                    _hoisted_9
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h2", _hoisted_11, _toDisplayString(__props.variant.name), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_AppPrice, {
                value: __props.variant.cost_price
              }, null, 8, ["value"])
            ]),
            (Number(__props.variant.origin_price) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createVNode(_component_AppPrice, {
                    value: __props.variant.origin_price
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_b_form_select, {
              "model-value": __props.variant.id,
              options: _unref(variantOptions),
              onChange: handleVariantChange
            }, null, 8, ["model-value", "options"])
          ]),
          (__props.variant.price_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(PurchaseOption, {
                  variant: __props.variant,
                  kind: __props.purchaseKind,
                  "onUpdate:kind": handleSelectPurchaseKind
                }, null, 8, ["variant", "kind"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_AppStepper, {
              "model-value": __props.quatity,
              "onUpdate:modelValue": handleQuatityChange
            }, null, 8, ["model-value"]),
            _createVNode(_component_AppLoadingButton, {
              class: "btn-add-cart",
              variant: "primary",
              pill: "",
              disabled: __props.quatity <= 0,
              onClick: handleAddToCart
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.purchaseKind === 'once' ? 'Add to cart' : 'Add subscription to cart'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          (__props.product.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString(__props.product.description), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})